import Gallery from "../components/Gallery";

import patagoniaHome from "../images/patagoniaHomepage.png";
import patagoniaActivities from "../images/patagoniaActivities.png";
import patagoniaActivities2 from "../images/patagoniaActivities2.png";
import patagoniaHiking from "../images/patagoniaHiking.png";
import oldWebsiteHome from "../images/oldWebsiteHome.png";
import oldWebsiteAbout from "../images/oldWebsiteAbout.png";
import oldWebsiteContact from "../images/oldWebsiteContact.png";
import newWebsiteHomepage from "../images/newWebsiteHomepage.png";
import gradeCalcImg1 from "../images/k8-1.png";
import gradeCalcImg2 from "../images/k8-2.png";
import gradeCalcImg3 from "../images/k8-3.png";
import gradeCalcImg4 from "../images/k8-4.png";

function Projects() {
  const alteredH2Style = {
    color: "rgba(220, 220, 220, 0.9)",
  };
  const grade_calc_images = [
    gradeCalcImg1,
    gradeCalcImg2,
    gradeCalcImg3,
    gradeCalcImg4,
  ];
  const images_website_current = [newWebsiteHomepage];
  const images_website_old = [
    oldWebsiteHome,
    oldWebsiteAbout,
    oldWebsiteContact,
  ];
  const images_patagonia = [
    patagoniaHome,
    patagoniaActivities,
    patagoniaActivities2,
    patagoniaHiking,
  ];

  return (
    <>
      <div id="projects" className="container">
        <div className="page">
          <h3>Projects</h3>
          <h2 style={alteredH2Style}>Check out my projects!</h2>

          <div className="projectbox">
            <div className="project-description">
              <h4>Kalcul8 - Grade Calculator</h4>
              <h5>Est. Dec 2025 | Currently Maintained</h5>
              <div className="project-text">
                Kalcul8 is a cross-platform grade tracking app built with React
                Native, Expo, and TypeScript, available on web with mobile
                versions in progress. The app features a standalone
                weighted-grade calculator that persists state via browser
                cookies, as well as a full account-based experience powered by
                Firebase Auth and Firestore. Users can create accounts, manage
                multiple classes, and track their grades over time. With a few
                new features and mobile versions on the way, stay tuned for
                updates!
              </div>
              <a
                href="https://kalcul8grades.com"
                target="_blank"
                rel="noreferrer"
              >
                <button className="project-link-btn">Visit Kalcul8!</button>
              </a>
            </div>
            <Gallery images={grade_calc_images} />
          </div>

          <div className="projectbox">
            <div className="project-description">
              <h4>SchuylerMcClean.com</h4>
              <h5>Est. May/June 2025 | Currently Maintained</h5>
              <div className="project-text">
                This website! I designed and built a dynamic React-based
                portfolio website using CSS and JavaScript, showcasing
                interactive visuals. To streamline development, I configured a
                continuous deployment pipeline via GitHub and AWS Amplify,
                automating updates and reducing deployment time. I also
                implemented HTTPS with TLS protocols and connected a custom
                domain through DNS settings to ensure secure and reliable
                access.
              </div>
            </div>
            <Gallery images={images_website_current} />
          </div>

          <div className="projectbox">
            <div className="project-description">
              <h4>SchuylerMcClean.com (old)</h4>
              <h5>Est. Dec 2024 | Not Maintained</h5>
              <div className="project-text">
                Similar to my updated website as featured above, this
                React-based portfolio uses CSS and JavaScript to showcase
                several pages, and utilizes a continuous deployment pipeline via
                GitHub and AWS Amplify. Additionally, HTTPS with TLS protocols
                are implemented as well as a custom domain name.
              </div>
            </div>
            <Gallery images={images_website_old} />
          </div>

          <div className="projectbox">
            <div className="project-description">
              <h4>Patagonia Informational Website</h4>
              <h5>Est. March 2025 | Not Maintained</h5>
              <div className="project-text">
                Crafted with HTML and CSS as part of a university assignment,
                this multi-page website offers an engaging and visually
                appealing guide to exploring the Patagonia region of South
                America. Each page highlights exciting activities—such as hiking
                through mountain trails, kayaking, and spotting unique
                wildlife—giving visitors a vivid sense of adventure and
                discovery.
              </div>
            </div>
            <Gallery images={images_patagonia} />
          </div>
          <div className="sm-break"></div>
        </div>
      </div>
    </>
  );
}

export default Projects;
